import { render, staticRenderFns } from "./PanelChartInfo.vue?vue&type=template&id=83f88232&scoped=true"
import script from "./PanelChartInfo.vue?vue&type=script&lang=js"
export * from "./PanelChartInfo.vue?vue&type=script&lang=js"
import style0 from "./PanelChartInfo.vue?vue&type=style&index=0&id=83f88232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f88232",
  null
  
)

export default component.exports